/* ==========================================================================
   Maneuver Header - off-canvas mobile drawer logic
   Upload this file to Assets as header-maneuver.js (loaded via
   {{ 'header-maneuver.js' | asset_url | script_tag }} in the section)
   ========================================================================== */

(function () {
  function initHeader(header) {
    if (!header || header.dataset.mvInit === 'true') return;
    header.dataset.mvInit = 'true';

    var burger = header.querySelector('.mv-header__burger');
    var mobile = header.querySelector('.mv-header__mobile');
    var overlay = header.querySelector('.mv-header__overlay');
    var closeBtn = header.querySelector('.mv-header__mobile-close');

    function openMenu() {
      header.classList.add('mv-header--open');
      document.body.classList.add('mv-scroll-lock');
      if (burger) burger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      header.classList.remove('mv-header--open');
      document.body.classList.remove('mv-scroll-lock');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }

    if (burger && mobile) {
      burger.addEventListener('click', function () {
        if (header.classList.contains('mv-header--open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('mv-header--open')) {
        closeMenu();
      }
    });

    if (header.dataset.transparent === 'true') {
      var toggleScrolled = function () {
        if (window.scrollY > 40) {
          header.classList.add('mv-header--scrolled');
        } else {
          header.classList.remove('mv-header--scrolled');
        }
      };
      toggleScrolled();
      window.addEventListener('scroll', toggleScrolled, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.mv-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init if the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var header = e.target.querySelector('.mv-header');
    if (header) initHeader(header);
  });
})();